import React, { Component } from "react";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
//import { ProgressSpinner } from "primereact/components/progressspinner/ProgressSpinner";
import { Button } from "primereact/components/button/Button";
import { Growl } from "primereact/components/growl/Growl";
import { Dialog } from "primereact/components/dialog/Dialog";

//Imports from common
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
//import { formatId } from "../../common/FormatId";

export class Clients extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      test: "",
      clientList: [],
      clientSelected: false,
      clientEdited: false,
      clientAdded: false,
      clientDeleted: false,
      selectedClient: "",
      clientAddressLine1: "",
      clientAddressLine2: "",
      clientBusinessDescription: "",
      clientBusinessName: "",
      clientCity: "",
      clientCodeTag: "",
      clientCountryCode: "",
      clientCurrency: "",
      clientCurrencyDecimalPlaces: "",
      clientCurrencySymbol: "",
      clientId: "",
      clientLastUpdatedDateTime: "",
      clientOpeningHours: "",
      clientPostalZipCode: "",
      clientTimezone: "",
      clientType: "",
      clientTelephoneNumber: "",
      clientEmail: "",
      editedClientBusinessName: "",
      editedClientAddressLine1: "",
      editedClientAddressLine2: "",
      editedClientPostalZipCode: "",
      editedClientCity: "",
      editedClientEmail: "",
      editedClientTelephoneNumber: ""
    };
  }

  componentDidMount() {
    this.getClients();
  }

  getClients = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.type = "Client";

    await api("businessApiV1BusinesslistByType", businessRequest).then(res => {
      if (res.data.businesses !== undefined) {
      }

      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          clientList: businessResponse.businesses
        });
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving data, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true });
  };

  editClient = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = this.state.clientId;
    businessRequest.lastUpdatedDateTime = this.state.clientLastUpdatedDateTime;
    if (this.state.editedClientBusinessName !== this.state.clientBusinessName) {
      businessRequest.businessName = this.state.editedClientBusinessName;
    }
    businessRequest.addressLine1 = this.state.editedClientAddressLine1;
    businessRequest.addressLine2 = this.state.editedClientAddressLine2;
    businessRequest.postalZipCode = this.state.editedClientPostalZipCode;
    businessRequest.city = this.state.editedClientCity;
    businessRequest.email = this.state.editedClientEmail;
    businessRequest.telephoneNumber = this.state.editedClientTelephoneNumber;

    await api("businessApiV1BusinessUpdate", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          clientEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Client successfully updated",
          life: 3000
        });
        this.getClients();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the client, please try again",
          life: 3000
        });
      }
    });
  };

  addClient = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.businessName = this.state.editedClientBusinessName;
    businessRequest.addressLine1 = this.state.editedClientAddressLine1;
    businessRequest.addressLine2 = this.state.editedClientAddressLine2;
    businessRequest.postalZipCode = this.state.editedClientPostalZipCode;
    businessRequest.city = this.state.editedClientCity;
    businessRequest.email = this.state.editedClientEmail;
    businessRequest.telephoneNumber = this.state.editedClientTelephoneNumber;
    businessRequest.type = "Client";
    businessRequest.timezone = "GMT";
    businessRequest.currency = "GBP";
    businessRequest.countryCode = "GBR";
    businessRequest.configJsonStr = JSON.stringify({ "": "" });

    await api("businessApiV1CreateBusiness", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          clientEdited: false,
          clientAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Client successfully created",
          life: 3000
        });
        this.getClients();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the client, please try again",
          life: 3000
        });
      }
    });
  };

  deleteClient = async () => {
    this.setState({ loaded: false });

    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = this.state.clientId;
    businessRequest.lastUpdatedDateTime = this.state.clientLastUpdatedDateTime;
    businessRequest.businessName = this.state.clientBusinessName;

    await api("businessApiV1EraseBusiness", businessRequest).then(res => {
      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState({
          clientSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Client successfully deleted",
          life: 3000
        });
        this.getClients();
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the client, please try again",
          life: 3000
        });
      }
    });
  };

  render() {
    return (
      <div className="ui-g dashboard">
        <Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <Dialog
          header="Delete Client"
          footer={
            <div>
              <Button
                label="Yes"
                onClick={() => {
                  this.setState({ clientDeleted: false });
                  this.deleteClient();
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#01a4ef"
                }}
              />
              <Button
                label="No"
                onClick={() => {
                  this.setState({ clientDeleted: false });
                }}
                style={{
                  float: "right",
                  color: "white",
                  backgroundColor: "#808080"
                }}
              />
            </div>
          }
          visible={this.state.clientDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ clientDeleted: false })}
        >
          Are you sure you want to delete?
        </Dialog>
        {this.state.loaded === false ? (
          <LoadScreen />
        ) : (
          <div className="ui-g-12">
            {/*Clients Card*/}
            {this.state.clientSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Name: </b>
                    <label>{this.state.clientBusinessName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 1: </b>
                    <label>{this.state.clientAddressLine1 || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Address Line 2: </b>
                    <label>{this.state.clientAddressLine2 || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Postcode: </b>
                    <label>{this.state.clientPostalZipCode || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>City: </b>
                    <label>{this.state.clientCity || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Email: </b>
                    <label>{this.state.clientEmail || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Contact Telephone: </b>
                    <label>
                      {this.state.clientTelephoneNumber || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Edit"
                    onClick={() => {
                      this.setState({
                        clientSelected: false,
                        clientEdited: true,
                        clientAdded: false,
                        editedClientBusinessName: this.state.clientBusinessName,
                        editedClientAddressLine1: this.state.clientAddressLine1,
                        editedClientAddressLine2: this.state.clientAddressLine2,
                        editedClientPostalZipCode: this.state
                          .clientPostalZipCode,
                        editedClientCity: this.state.clientCity,
                        editedClientEmail: this.state.clientEmail,
                        editedClientTelephoneNumber: this.state
                          .clientTelephoneNumber
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Delete"
                    onClick={() => {
                      this.setState({ clientDeleted: true });
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    className="secondary-btn"
                    label="View Sites"
                    onClick={() => {
                      localStorage.setItem("clientId", this.state.clientId);
                      window.location = "#/clientSites";
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    className="secondary-btn"
                    label="View Users"
                    onClick={() => {
                      localStorage.setItem("clientId", this.state.clientId);
                      window.location = "#/clientUsers";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Clients Card*/}
            {this.state.clientEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientBusinessName === "" ||
                          this.state.editedClientBusinessName === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientBusinessName || ""}
                        onChange={e =>
                          this.setState({
                            editedClientBusinessName: e.target.value
                          })
                        }
                      />
                      <label>Name *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientAddressLine1 === "" ||
                          this.state.editedClientAddressLine1 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientAddressLine1 || ""}
                        onChange={e =>
                          this.setState({
                            editedClientAddressLine1: e.target.value
                          })
                        }
                      />
                      <label>Address Line 1 *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientAddressLine2 === "" ||
                          this.state.editedClientAddressLine2 === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientAddressLine2 || ""}
                        onChange={e =>
                          this.setState({
                            editedClientAddressLine2: e.target.value
                          })
                        }
                      />
                      <label>Address Line 2</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientPostalZipCode === "" ||
                          this.state.editedClientPostalZipCode === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientPostalZipCode || ""}
                        onChange={e =>
                          this.setState({
                            editedClientPostalZipCode: e.target.value
                          })
                        }
                      />
                      <label>Postcode *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientCity === "" ||
                          this.state.editedClientCity === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientCity || ""}
                        onChange={e =>
                          this.setState({ editedClientCity: e.target.value })
                        }
                      />
                      <label>City *</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientEmail === "" ||
                          this.state.editedClientEmail === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientEmail || ""}
                        onChange={e =>
                          this.setState({ editedClientEmail: e.target.value })
                        }
                      />
                      <label>Email *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <input
                        className={
                          this.state.editedClientTelephoneNumber === "" ||
                          this.state.editedClientTelephoneNumber === undefined
                            ? "ui-inputtext"
                            : "ui-inputtext ui-state-filled"
                        }
                        type="text"
                        value={this.state.editedClientTelephoneNumber || ""}
                        onChange={e =>
                          this.setState({
                            editedClientTelephoneNumber: e.target.value
                          })
                        }
                      />
                      <label>Contact Telephone *</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <Button
                    label="Save"
                    onClick={() => {
                      this.state.clientAdded === true
                        ? this.addClient()
                        : this.editClient();
                    }}
                    style={{ float: "right" }}
                  />
                  <Button
                    label="Cancel"
                    onClick={() => {
                      this.state.clientAdded === true
                        ? this.setState({
                            clientSelected: false,
                            clientEdited: false,
                            clientAdded: false
                          })
                        : this.setState({
                            clientSelected: true,
                            clientEdited: false,
                            clientAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Clients Table*/}
            <div className="ui-g-12 card">
              <DataTable
                value={this.state.clientList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      clientSelected: true,
                      clientEdited: false,
                      clientAdded: false,
                      selectedClient: e.data,
                      clientAddressLine1: e.data.addressLine1,
                      clientAddressLine2: e.data.addressLine2,
                      clientBusinessDescription: e.data.businessDescription,
                      clientBusinessName: e.data.businessName,
                      clientCity: e.data.city,
                      clientCodeTag: e.data.codeTag,
                      clientCountryCode: e.data.countryCode,
                      clientCurrency: e.data.currency,
                      clientCurrencyDecimalPlaces: e.data.currencyDecimalPlaces,
                      clientCurrencySymbol: e.data.currencySymbol,
                      clientId: e.data.id,
                      clientLastUpdatedDateTime: e.data.lastUpdatedDateTime,
                      clientOpeningHours: e.data.openingHours,
                      clientPostalZipCode: e.data.postalZipCode,
                      clientTimezone: e.data.timezone,
                      clientType: e.data.type,
                      clientTelephoneNumber: e.data.telephoneNumber,
                      clientEmail: e.data.email
                    },
                    () => {
                      console.log(this.state.selectedClient);
                    }
                  );
                }}
                header="Clients"
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
                rows={10}
                emptyMessage="No Clients"
              >
                <Column
                  field="businessName"
                  header="Name"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine1"
                  header="Address Line 1"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="addressLine2"
                  header="Address Line 2"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="telephoneNumber"
                  header="Contact Telephone"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="city"
                  header="City"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <Column
                  field="email"
                  header="Email"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </DataTable>
            </div>
            <div className="ui-g-12">
              <Button
                label="Create New"
                onClick={() => {
                  this.setState({
                    clientSelected: false,
                    clientEdited: true,
                    clientAdded: true,
                    editedClientBusinessName: "",
                    editedClientAddressLine1: "",
                    editedClientAddressLine2: "",
                    editedClientPostalZipCode: "",
                    editedClientCity: "",
                    editedClientEmail: "",
                    editedClientTelephoneNumber: ""
                  });
                }}
                style={{ float: "right" }}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Clients/Clients.js